import React from 'react';

export const ContextWrapper = ({
  context: Context,
  component: Component,
  ...props
}) => {
  if (!Context) {
    return <Component {...props} />;
  }
  return (
    <Context.Consumer>
      {ctx =>
        <Component
          {...props}
          context={Context}
          getContext={ctx.getContext}
          value={ctx.getContext().getValue(props.name)}
        />
      }
    </Context.Consumer>
  );
};

const Wrapper = Component => props =>
  <ContextWrapper
    {...props}
    component={Component}
  />;

export default Wrapper;
